import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { LeavesService } from 'src/app/modules/leaves/services/leaves.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { LoaderService } from 'src/app/auth/services/loader.service';
import { WfhCreateComponent } from '../wfh-create/wfh-create.component';
import { CURRENT_PAGE, ITEMS_PER_PAGE, PAGE_LENGTH, PAGE_SIZE_OPTIONS } from 'src/app/shared/constants/pagination.constants';
import { WfhService } from '../../services/wfh.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Users } from 'src/app/modules/users/models/users';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';


const dialogConfig= new MatDialogConfig();
dialogConfig.disableClose = true;
dialogConfig.autoFocus = true;

@Component({
  selector: 'app-wfh-details',
  templateUrl: './wfh-details.component.html',
  styleUrls: ['./wfh-details.component.css']
})
export class WfhDetailsComponent implements OnInit {

  @ViewChild('paginator', {static: true}) paginator: MatPaginator;

  displayedColumns: string[] = ['user_name','org_name', 'wfh_from','wfh_to','wfh_days','wfh_reason','wfh_status'];
 
  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;

  public page_length:number = PAGE_LENGTH;

  public items_per_page:number = ITEMS_PER_PAGE;

  public current_page:number = CURRENT_PAGE;

  public wfhDataSource:any;
  public searchUserNameCtrl = new FormControl('', Validators.required);
  public user_details: any = this.authservice.getUserDetails();
  users: any[] = [];  // Initialize as an empty array to avoid undefined error
  usersReport: any;

  constructor(
    private wfhService:WfhService,
    private dialog:MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private loaderService:LoaderService,
    private userService: UsersService,
    private authservice: AuthenticationService,



  ) { }
  role: any;
  // Check if user is an admin
  isAdmin(): boolean {
    return this.role && this.role['2']?.name === '2'; // Adjust key and type as per your requirements
  }
  ngOnInit(): void {
    this.loadIcon();
    this.getWfh();
    console.log(this.user_details.user_id);
    this.getReportingList(this.user_details.user_id);
    const roleData = localStorage.getItem('role');
    const user_details = localStorage.getItem('user_details');
    if (roleData) {
      this.role = JSON.parse(roleData); // Parse JSON string to an object
      console.log('Role Object:', this.role); // Debugging: View role object
    } else {
      console.error('Role data not found in localStorage.');
    }
  }

  ngAfterViewInit(){
    if(this.wfhDataSource != undefined){
      this.wfhDataSource.paginator = this.paginator;
    }
  }
  onOptionSelected(event: any): void {
    const selectedUser = event.option.value;
    if (selectedUser) {
      this.AdvancedSearchForm.patchValue({
        user_id: selectedUser.user_id, // Assuming 'id' is the key for user ID
      });
    }
  }
  getReportingList(userId: string): void {
    let filterParams = {};
    filterParams['sort'] = '-id';

    if (userId !== undefined) {
      filterParams['filter[user_id]'] = userId;
    }

    this.userService.getReportingListUsers(filterParams).subscribe((res: any) => {
      this.usersReport = res.body;
      console.log('Reporting users:', this.usersReport); // Check if data is received correctly
    });
  }

  loadIcon():void{
    this.matIconRegistry.addSvgIcon(
      "filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/SVG/filter.svg")
      );
  }

  getWfh():void{
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addFilterParameters();
    filterParams["user_id"] = this.AdvancedSearchForm.value.user_id;
    filterParams["from_date"] = this.AdvancedSearchForm.value.from_date;
    filterParams["to_date"] = this.AdvancedSearchForm.value.to_date;
    this.wfhService.getWfh(filterParams).subscribe(
      (res)=>{
        // console.log(`Responsive Data :: `,res);
        this.loaderService.isTableLoding.next(false);

        this.page_length = res.headers.get('X-Pagination-Total-Count');
        this.current_page = res.headers.get('X-Pagination-current-page');
        this.items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.wfhDataSource = new MatTableDataSource<any>(res.body);

      }
    );
  }
  updateStatus(id: number | string, status: number): void {
    // Find the record by id
    const record = this.wfhDataSource.data.find((r: any) => r.id === id);
    console.log(record);
    if (record) {
      // Update the status of the specific record
      record.wfh_status = status;

      // Call the service method to update the status in the backend
      const updatedRecord = {
        ...record,
        wfh_status: status  // Update the status based on action
      };

      this.wfhService.updateWfhStatus(updatedRecord).subscribe(response => {
        if (response.success) {
          // Successfully updated status
          console.log('Status updated successfully');
        } else {
          console.error('Failed to update status:', response);
        }
      });
    }
  }
  AdvancedSearchForm = new FormGroup({
      org_id: new FormControl(),
      from_date: new FormControl(),
      to_date: new FormControl(),
      user_id: new FormControl()
    });
  createWfh():void{
    dialogConfig.width ="40%";
    dialogConfig.data = {
      holiday_id : undefined
    };
    
    this.dialog.open(WfhCreateComponent,dialogConfig);

    // UPDATE CONTACT DETAILS AFTER CREATING THE CONTACT
    this.dialog.afterAllClosed.subscribe(e=>{
      this.getWfh();
    });
  }
  AdvancedSearchFormSubmit(): void {
    this.getWfh();
  }
  displaySearchUserName(user: any): string {
    return user ? user.name : ''; // Display 'name', or empty if no user
  }
  addFilterParameters():Object{
    let filterParams = {};
    filterParams['page']=this.current_page;
    filterParams["per-page"]=this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  handlePage(e?: any):void {
    if(e){
      this.current_page = e.pageIndex+1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.getWfh();
  }

}

